import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getDietCompare = async (dietCode, dietQuality, idealCode, idealQuality, userId) => {
  // userId is optional but it makes no sense to make the call without diet vars
  if (!dietCode || !dietQuality || !idealCode || !idealQuality) {
    return false;
  }

  const apiURL =
    API_HOST + '/diets/compare/' + dietCode + '/' + dietQuality + '/' + idealCode + '/' + idealQuality + '?u=' + userId;
  const { token, userID } = useCurrentUser();
  try {
    const { data } = await axios.get(apiURL, {
      headers: {
        Authorization: 'Bearer ' + token,
        'x-dqpn-user-id': userID,
      },
    });
    return data;
  } catch (error) {
    console.error(error);
  }
};
